const mktApps = {
    appList: [],
    loadingApps: true
};

export default mktApps;
